export default "__VITE_ASSET__CzBQrHCm__"